import { type FC } from "react";
import { Box, Typography } from "@mui/material";
import Inventory2OutlinedIcon from "@mui/icons-material/Inventory2Outlined";
import { FormattedMessage } from "react-intl";

import { useCartonsClosedToday } from "@/views/closing/hooks/use-closed-today-cartons";

interface ClosedTodayProps {
	readonly machineId: string;
}

export const ClosedToday: FC<ClosedTodayProps> = ({ machineId }) => {
	const { data } = useCartonsClosedToday(machineId);
	return (
		<Box
			sx={{
				display: "flex",
				flexDirection: "column",
				alignItems: "center",
				justifyContent: "center",
				gap: 1,
				height: "100%",
				border: 1,
				borderRadius: 1,
				borderColor: "divider",
				padding: 1,
				flex: 1,
			}}
		>
			<Inventory2OutlinedIcon sx={{ fontSize: 24 }} />
			<Typography variant="h5">{Intl.NumberFormat("en-US").format(data?.closedToday || 0)}</Typography>
			<Typography variant="h6" sx={{ textAlign: "center" }}>
				<FormattedMessage id="Closed Today" defaultMessage="Closed Today" />
			</Typography>
		</Box>
	);
};
